import ArrowIcon from "@icons/arrowIcon.svg";
import LearningPathItemVideos from "@icons/learningPathItemVideos.svg";
import LearningPathItemUnits from "@icons/learningPathItemUnits.svg";
import LearningPathItemSubjects from "@icons/learningPathItemSubjects.svg";
import styles from "./learningPathOrModuleItem.module.scss";

export const LearningPathOrModuleItem = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";

  const renderIconContainer = (count: number, label: string, icon: any) =>
    count > 0 && (
      <div className={styles["iconContainer"]}>
        {icon}
        <div className={styles["label"]}>
          {count} {label}
        </div>
      </div>
    );

  return (
    <div className={styles["container"]}>
      {props.img && (
        <div className={styles["imgContainer"]}>
          <img src={props.img} alt={props.description} loading="lazy" />
        </div>
      )}

      <div className={styles["contentContainer"]}>
        <h2>
          <LinkComponent href={props.slug} className={styles["name"]}>
            {props.name}
          </LinkComponent>
        </h2>

        <div className={styles["description"]}>{props.description}</div>

        <div className={styles["bottomContainer"]}>
          <div className={styles["iconsContainer"]}>
            {renderIconContainer(
              props.numberOfUnits,
              props.unitLabel,
              <LearningPathItemUnits />,
            )}
            {renderIconContainer(
              props.numberOfSubjects,
              props.subjectsLabel,
              <LearningPathItemSubjects />,
            )}
            {renderIconContainer(
              props.numberOfVideos,
              props.videosLabel,
              <LearningPathItemVideos />,
            )}
          </div>
          {!props.isMobile && (
            <div className={styles["goPath"]}>
              {props.goPathLabel} <ArrowIcon />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

interface Props {
  isMobile: boolean;
  img: string;
  description: string;
  slug: string;
  name: string;
  numberOfUnits: number;
  unitLabel: string;
  numberOfVideos: number;
  videosLabel: string;
  numberOfSubjects: number;
  subjectsLabel: string;
  goPathLabel: string;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
